import './style.modules.scss'

import React from 'react'
import xss from 'xss'

export type AdviceSpotlightProps = {
  headline: string
  eyebrow: string
  callout: string
  description: string
  testId?: string
}

export const AdviceSpotlight = (props: AdviceSpotlightProps) => {
  const { headline, eyebrow, callout, description, testId } = props
  const horizontalRuleClass = `AdviceSpotlight-horizontalRule u-border u-borderWidthLarge u-borderTop AdviceSpotlight-borderRadius`

  return (
    <div
      className="AdviceSpotlight u-adel-reset u-sizeConstrained"
      data-testid={testId ? `${testId}` : undefined}
    >
      <div
        className={`u-flex u-flexAlignItemsCenter u-flexJustifyCenter ${
          headline ? 'u-paddingBottom32' : 'u-paddingBottom40'
        }`}
      >
        <hr className={horizontalRuleClass} />
        {headline && (
          <>
            <h3
              className="AdviceSpotlight-headline u-paddingHoriz20 u-sm-paddingHoriz8 u-textPrimary u-textMedium u-textSizeMsrp2 u-textColorNeutral u-textLineHeightHeading u-textCenter"
              dangerouslySetInnerHTML={{ __html: xss(headline) }}
            ></h3>
            <hr className={horizontalRuleClass} />
          </>
        )}
      </div>
      <div className={`u-paddingHoriz40 u-sm-paddingHoriz0`}>
        {eyebrow && (
          <p
            className="Type-5 u-textEyebrow u-textPrimary u-paddingBottom8"
            dangerouslySetInnerHTML={{ __html: xss(eyebrow) }}
          ></p>
        )}
        {callout && (
          <p
            className={`u-textSecondary u-textNormal u-textColorMidnightBlue u-textSizeMsrp4 u-textLineHeightHeading ${
              description ? 'u-paddingBottom8' : 'u-paddingBottom40'
            } ${eyebrow ? '' : 'u-paddingTop8'}`}
            dangerouslySetInnerHTML={{ __html: xss(callout) }}
          ></p>
        )}
        {description && (
          <p
            className="AdviceSpotlight-description Content u-textPrimary u-textNormal u-textSizeMsr u-textColorNeutral u-textDefault u-paddingBottom40"
            dangerouslySetInnerHTML={{ __html: xss(description) }}
          ></p>
        )}
      </div>
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyCenter">
        <hr className={horizontalRuleClass} />
      </div>
    </div>
  )
}
